<section class="fileupload-container">
  <compass-callout>
    <compass-callout-title>Upload requirements</compass-callout-title>
    <compass-callout-content>
      <ul class="fileupload-list">
        <li>No technical data included</li>
        <li>Maximum of 5 files</li>
        <li>Maximum file size: 5MB per file</li>
        @if (allowedExtensions().length > 0) {
          <li>Acceptable formats:</li>
          {{ allowedExtensions() | espAllowedExtensions }}
        }
      </ul>
    </compass-callout-content>
  </compass-callout>

  @if (isTechnicalConfirmationVisible()) {
    <mat-checkbox
      [class.ng-invalid]="!checkboxControl.valid && checkboxControl.touched"
      [formControl]="checkboxControl"
      (change)="emitFiles()"
    >
      I confirm that no Technical Data is included in the attachment.
      <mat-icon
        class="icon-tooltip"
        compassIcon="information"
        matTooltip="Technical data means information needed to design, develop, produce, operate, repair, or maintain an aircraft, engine, or related system."
      ></mat-icon>
    </mat-checkbox>
  }

  <mat-form-field class="fileupload-form-field">
    <input
      matInput
      required
      class="file-input"
      [formControl]="fileUploadControl"
    />
    @if (fileUploadControl.touched && isErrorVisible()) {
      <mat-error>
        @if (tooManyFiles()) {
          <span class="fileupload-error-message"
            >Please upload maximum 5 files. Currently {{ filesNumber() }} files
            are uploaded.</span
          >
        }
        @if (wrongExtension()) {
          <span class="fileupload-error-message">
            {{ wrongExtensionsList() | espWrongExtensionsMessage }}
          </span>
        }
        @if (tooLargeFile()) {
          <span class="fileupload-error-message">
            File: {{ tooLargeFilesNames() }} size exceeds {{ maxFileSize() }}MB.
          </span>
        }
      </mat-error>
    }
  </mat-form-field>

  <div>
    <input
      type="file"
      #fileUpload
      [accept]="allowedExtensions() | espAllowedExtensions"
      (change)="onFileSelected()"
      class="file-input"
    />

    <button
      mat-button
      compass-button
      fullWidth
      type="button"
      (click)="fileUpload.click()"
    >
      <mat-icon compassIcon="upload"></mat-icon>
      Upload file
    </button>
  </div>

  <div class="fileupload-files-container">
    @for (file of draftFilesForDisplay(); track file.filename) {
      <div class="fileupload-file">
        <span>{{ file.filename || "No file uploaded yet." }}</span>
        <button
          mat-icon-button
          aria-label="delete"
          (click)="removeDraftFile(file)"
          type="button"
          class="delete-button"
        >
          <mat-icon svgIcon="esp-delete"></mat-icon>
        </button>
      </div>
    }
    @if (uploadedFilesVisible()) {
      @for (file of uploadedFilesSignal(); let index = $index; track file) {
        <div class="fileupload-file">
          <span>{{ file.name || "No file uploaded yet." }}</span>
          <button
            mat-icon-button
            aria-label="delete"
            (click)="removeUploadedFile(index, file.name)"
            type="button"
            class="delete-button"
          >
            <mat-icon svgIcon="esp-delete"></mat-icon>
          </button>
        </div>
      }
    }
  </div>
</section>
